import { useEffect } from 'react'

export default function DocsRedirect() {
  useEffect(() => {
    // Redirect to MkDocs site
    window.location.href = '/docs/'
  }, [])

  return (
    <div className="section-container py-20 text-center">
      <p className="text-gray-600">Redirecting to documentation...</p>
    </div>
  )
}
